import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {MissionsService} from "../services/missions.service";
import {CONSTANTS} from "../../constants";

@Injectable({
  providedIn: 'root'
})
export class MissionResolver  {

  constructor(private _missionsService: MissionsService,
              private _router: Router) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): void {
    const missionId: string = route.params['missionId'];
    this._missionsService.selectMission(missionId)
      .then(() => {
      this._router.navigateByUrl(`${CONSTANTS.ROUTES.HOME}/${CONSTANTS.ROUTES.MISSION_CONFIG}/${encodeURIComponent(missionId)}/${CONSTANTS.ROUTES.MISSION_CONFIG_MENU}`);
    })
  }
}
